<template>
	<div class="autoLogin">
		<img src="./loading.gif" alt="">
		<p>自动登录中，请稍后 ... </p>
	</div>
</template>

<script>
  import { setToken, getToken } from '@/utils/auth'
  import Cookies from 'js-cookie'
  export default {
    name: 'login',
    created() {
      this.autoLogin()
    },
    methods: {
      autoLogin() {
        const routeData = this.$route.query
        // removeToken()
        // this.$store.getters.roles = ''
        if (routeData.token) {
          this.$store.commit('SET_TOKEN', this.$route.query.token)
          setToken(this.$route.query.token)
          setTimeout(() => {
            if (getToken()) {
              if (routeData.isService && routeData.isService == 1) {
                Cookies.remove('agentAuth')
                this.$confirm('将跳转到'+ process.env.VUE_APP_CHAT_URL +', 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  window.location.href = process.env.VUE_APP_CHAT_URL
                  return false
                }).catch(() => {

                });
              } else {
                this.$router.push({
                  path: '/'
                })
              }
            }
          }, 1000)
        } else {
          this.$message.error('参数错误')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
	.autoLogin{
		width: 100%;
		height: 100%;
		padding-top: 60px;
		text-align: center;
		background: #fff;
		img{
			width: 600px;
		}
		p{
			font-size: 18px;
			color: #666;
			margin-top: -30px;
		}
	}
</style>
